import axios from "axios";

const axiosClientSevan = axios.create({
    baseURL: `${process.env.REACT_APP_SEVAN_BASE_URL}`,
  });

  axiosClientSevan.interceptors.request.use((config) => {
  // const key = process.env.REACT_APP_SEVAN_API_KEY
  config.headers['API-PASSWORD'] = "g#R9$k8z";
  return config;
});

axiosClientSevan.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      throw error;
    }
  );
  
  export default axiosClientSevan;